import { withState } from 'recompose';

export default withState('error', 'updateError', false);
